module.exports = __webpack_public_path__ + "static/media/Wind_Zone_France.39e66037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Wind_Zone_France.png
// module id = 1343
// module chunks = 0